import { TabsList, TabsTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";

const TRIGGER =
  "h-full rounded-full border-0 border-t border-t-transparent px-2.5 font-semibold text-muted-foreground text-sm data-active:border-t-foreground/5 data-active:bg-accent data-active:text-secondary-foreground";

const RewardCenterTabs: FC = () => {
  const {
    state: { enabledTabs },
  } = useRewardCenter();
  const t = useTranslations();

  return (
    <TabsList
      variant="ghost"
      className="h-12 w-full gap-1 rounded-full bg-secondary p-1.5 group-data-horizontal/tabs:h-12"
    >
      <TabsTrigger variant="ghost" value="rewards" className={TRIGGER}>
        {t("reward_center.tabs.rewards")}
      </TabsTrigger>
      {enabledTabs?.history && (
        <TabsTrigger variant="ghost" value="history" className={TRIGGER}>
          {t("reward_center.tabs.history")}
        </TabsTrigger>
      )}
      {enabledTabs?.faq && (
        <TabsTrigger variant="ghost" value="faq" className={TRIGGER}>
          {t("reward_center.tabs.faq")}
        </TabsTrigger>
      )}
    </TabsList>
  );
};

export default RewardCenterTabs;
